import { Injectable, signal } from '@angular/core'

@Injectable({
	providedIn: 'root',
})
export class HideWalletService {
	readonly #currentHideStatus = signal<'hide' | 'show'>('show')

	setHideStatus(lang: 'hide' | 'show') {
		this.#currentHideStatus.set(lang)
	}

	get currentHideStatus() {
		return this.#currentHideStatus.asReadonly()
	}
}
